var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconBox3 = function SvgIconBox3(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5,
    stroke: "#F6F6F6",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M43.75 33.333V16.667a4.167 4.167 0 0 0-2.083-3.605L27.083 4.73a4.166 4.166 0 0 0-4.166 0L8.333 13.063a4.166 4.166 0 0 0-2.083 3.604v16.666a4.167 4.167 0 0 0 2.083 3.605l14.584 8.333a4.167 4.167 0 0 0 4.166 0l14.584-8.334a4.167 4.167 0 0 0 2.083-3.604Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.706 19.412v11.365l-9.412 5.694M15.625 18.946 25 13.53l9.375 5.416M15.294 20v10.974l9.412 5.497"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.813 14.5 25 25.02 43.188 14.5M25 46V25"
  }))));
};
export default SvgIconBox3;